import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Thanetogoacabs() {



    const cardData = {
"keyword": "Thane to Goa Cabs",

"headingDescription":
  "Om Sai Cab offers reliable and comfortable Thane to Goa Cabs service for travelers seeking a safe, affordable, and enjoyable road trip to Goa’s famous beaches and tourist attractions. Whether you are planning a family vacation, honeymoon trip, friends getaway, beach holiday, sightseeing tour, or corporate travel, our taxi service ensures a smooth and stress-free journey from Thane to Goa. With experienced drivers familiar with Konkan highway routes, clean air-conditioned vehicles maintained for long-distance comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience for every traveler. Our fleet includes sedans, SUVs, Innova cars, tempo travellers, and premium vehicles suitable for solo travelers, families, and groups.",

"topPlaces": [
  {
    "title": "Panaji",
    "description": "Panaji is the capital city of Goa and a major destination for tourism, business, and commercial activities."
  },
  {
    "title": "Calangute",
    "description": "Calangute is a popular Goa destination known for beaches, hotels, resorts, and tourism businesses."
  },
  {
    "title": "Baga",
    "description": "Baga is a famous beach destination in Goa known for nightlife, restaurants, and tourist attractions."
  },
  {
    "title": "Candolim",
    "description": "Candolim is a premium area in Goa known for luxury resorts, hospitality services, and commercial spaces."
  },
  {
    "title": "Margao",
    "description": "Margao is a major commercial city in South Goa with markets, businesses, and transport connectivity."
  },
  {
    "title": "Vasco da Gama",
    "description": "Vasco da Gama is an important industrial and commercial city near Mormugao Port."
  },
  {
    "title": "Mapusa",
    "description": "Mapusa is a key market town in Goa known for shopping, trade, and local business activities."
  },
  {
    "title": "Dabolim Airport",
    "description": "Dabolim Airport is Goa's main airport connecting the state with major cities and destinations."
  },
  {
    "title": "Verna Industrial Estate",
    "description": "Verna Industrial Estate is a major business and industrial area with manufacturing companies."
  },
  {
    "title": "South Goa",
    "description": "South Goa is known for peaceful beaches, resorts, hospitality businesses, and tourism opportunities."
  }
],



services: [
  {
    name: "Thane to Goa Cabs",
    description: "Thane to Goa cabs service provides reliable transportation for travelers planning comfortable road journeys from Thane to Goa. Vehicles ensure smooth highway travel suitable for tourism, beach holidays, sightseeing tours, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Thane. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Thane to Goa Cab Service",
    description: "Thane to Goa cab service offers premium transportation solutions for passengers planning direct Goa travel from Thane. Comfortable vehicles ensure reliable highway journeys suitable for tourism, family holidays, business travel, and weekend trips. Professional chauffeurs ensure punctual pickup and smooth transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Thane. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Thane to Goa Taxi Service",
    description: "Thane to Goa taxi service provides dependable transportation for travelers seeking safe and comfortable Goa road trips. Vehicles ensure smooth highway journeys suitable for sightseeing tours, tourism travel, and beach vacations. Professional chauffeurs ensure reliable pickup and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Thane. Flexible booking options allow convenient taxi service reservations."
  },
  {
    name: "Thane to Goa Cab Booking",
    description: "Thane to Goa cab booking service provides easy and convenient transportation reservations for travelers planning Goa vacations from Thane. Comfortable vehicles ensure reliable highway journeys suitable for tourism travel and family holidays. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, and nearby locations across Thane. Flexible booking options allow convenient cab booking reservations."
  },
  {
    name: "Thane to Goa One Way Cab",
    description: "Thane to Goa one way cab service provides economical transportation for travelers requiring direct one-side travel between Thane and Goa. Vehicles ensure smooth highway journeys suitable for solo travelers, couples, tourists, and family vacations. Professional chauffeurs ensure reliable pickup and safe transportation services throughout the route. Pickup services are available across Thane including homes, offices, hotels, and nearby areas. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Thane to Goa Outstation Cab",
    description: "Thane to Goa outstation cab service offers dependable long-distance transportation for travelers planning Goa road trips from Thane. Comfortable vehicles ensure smooth and safe highway travel suitable for tourism, beach holidays, and family travel. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Thane. Flexible booking options allow convenient outstation cab reservations."
  },
  {
    name: "Thane to Goa Innova Cab",
    description: "Thane to Goa Innova cab service provides spacious transportation for families and groups planning comfortable Goa road journeys. Innova vehicles ensure smooth highway travel with comfortable seating and luggage space suitable for long-distance travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby locations across Thane. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Thane to Goa Innova Crysta Cab",
    description: "Thane to Goa Innova Crysta cab service offers luxury transportation with premium interiors and smooth highway performance for Goa vacations. Innova Crysta vehicles are ideal for family holidays, corporate travel, tourism trips, and VIP transportation. Professional chauffeurs ensure reliable pickup and premium transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby areas across Thane. Flexible booking options allow convenient Innova Crysta cab reservations."
  },
  {
    name: "Thane to Goa Ertiga Cab",
    description: "Thane to Goa Ertiga cab service provides affordable and spacious transportation for small families and groups traveling to Goa. Ertiga vehicles ensure comfortable highway journeys suitable for tourism, beach holidays, and sightseeing travel. Professional chauffeurs ensure dependable pickup and smooth transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby areas across Thane. Flexible booking options allow convenient Ertiga cab reservations."
  },
  {
    name: "Thane to Goa Luxury Cab",
    description: "Thane to Goa luxury cab service provides premium transportation with luxury vehicles suitable for comfortable long-distance Goa travel. Vehicles offer spacious seating, premium interiors, and smooth highway performance ideal for tourism, family vacations, and executive travel. Professional chauffeurs ensure safe driving and premium transportation services throughout the route. Pickup services are available from homes, hotels, offices, and nearby locations across Thane. Flexible booking options allow convenient luxury cab reservations."
  },
  {
    name: "Thane to Goa AC Taxi Service",
    description: "Thane to Goa AC taxi service offers air-conditioned transportation for comfortable and relaxing road journeys between Thane and Goa. Vehicles ensure cool and smooth highway travel suitable for tourism, beach vacations, and family holidays. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, and nearby locations across Thane. Flexible booking options allow convenient AC taxi reservations."
  },
  {
    name: "Ghodbunder to Goa Cab Service",
    description: "Ghodbunder to Goa cab service provides reliable transportation for travelers planning direct Goa road trips from Ghodbunder. Comfortable vehicles ensure smooth highway journeys suitable for tourism, beach holidays, and family vacations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby areas across Ghodbunder. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Ghodbunder Road to Goa Cabs",
    description: "Ghodbunder Road to Goa cabs service offers dependable transportation for passengers seeking comfortable road journeys to Goa. Vehicles ensure reliable highway travel suitable for tourism travel, sightseeing tours, and weekend holidays. Professional chauffeurs ensure safe driving and smooth transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby areas along Ghodbunder Road. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Ghodbunder to Goa Taxi",
    description: "Ghodbunder to Goa taxi service provides comfortable transportation for travelers planning direct Goa travel with spacious and reliable vehicles. Vehicles ensure smooth highway journeys suitable for tourism, beach vacations, and family travel. Professional chauffeurs ensure dependable pickup and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and nearby locations across Ghodbunder. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Ghodbunder to Goa One Way Cab",
    description: "Ghodbunder to Goa one way cab service provides economical transportation for travelers requiring direct one-side travel to Goa. Comfortable vehicles ensure smooth highway journeys suitable for tourists, couples, and family vacations. Professional chauffeurs ensure reliable pickup and safe transportation services throughout the route. Pickup services are available across Ghodbunder including homes, offices, hotels, and nearby locations. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Ghodbunder to Goa Outstation Cab",
    description: "Ghodbunder to Goa outstation cab service offers dependable long-distance transportation for travelers planning comfortable Goa road trips. Vehicles ensure reliable highway journeys suitable for tourism, sightseeing tours, and beach holidays. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby areas across Ghodbunder. Flexible booking options allow convenient outstation cab reservations."
  },
  {
    name: "Ghodbunder to Goa Cab Booking",
    description: "Ghodbunder to Goa cab booking service provides easy transportation reservations for travelers planning Goa holidays from Ghodbunder. Comfortable vehicles ensure smooth highway journeys suitable for tourism, family vacations, and holiday travel. Professional chauffeurs ensure safe driving and reliable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and nearby locations across Ghodbunder. Flexible booking options allow convenient cab booking reservations."
  },
  {
    name: "Ghodbunder to Goa Innova Cab",
    description: "Ghodbunder to Goa Innova cab service provides spacious transportation for families and groups traveling comfortably to Goa. Innova vehicles ensure smooth highway journeys with comfortable seating and luggage space suitable for long-distance travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, and nearby areas across Ghodbunder. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Ghodbunder to Goa Ertiga Cab",
    description: "Ghodbunder to Goa Ertiga cab service offers economical and spacious transportation for small families and groups planning Goa vacations. Ertiga vehicles ensure comfortable highway journeys suitable for tourism and beach travel. Professional chauffeurs ensure reliable pickup and smooth transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby locations across Ghodbunder. Flexible booking options allow convenient Ertiga cab reservations."
  },
  {
    name: "Kalyan Dombivli to Goa Cabs",
    description: "Kalyan Dombivli to Goa cabs service provides reliable transportation for travelers planning direct road journeys to Goa. Comfortable vehicles ensure smooth highway travel suitable for tourism, family holidays, and sightseeing tours. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby areas across Kalyan Dombivli. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Kalyan to Goa Cab Service",
    description: "Kalyan to Goa cab service offers comfortable transportation for passengers planning Goa vacations from Kalyan. Vehicles ensure reliable highway journeys suitable for beach holidays, tourism travel, and family outings. Professional chauffeurs ensure punctual pickup and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Kalyan. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Dombivli to Goa Taxi Service",
    description: "Dombivli to Goa taxi service provides dependable transportation for travelers seeking smooth and comfortable Goa road trips from Dombivli. Vehicles ensure safe highway journeys suitable for tourism, family vacations, and weekend travel. Professional chauffeurs ensure reliable pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby areas across Dombivli. Flexible booking options allow convenient taxi service reservations."
  },
  {
    name: "Kalyan to Goa Cab Booking",
    description: "Kalyan to Goa cab booking service provides quick and convenient transportation reservations for travelers planning Goa road trips. Comfortable vehicles ensure smooth highway journeys suitable for tourism, family vacations, and sightseeing tours. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby areas across Kalyan. Flexible booking options allow convenient cab booking reservations."
  },
  {
    name: "Dombivli to Goa One Way Cab",
    description: "Dombivli to Goa one way cab service provides economical transportation for travelers requiring direct one-side travel between Dombivli and Goa. Vehicles ensure smooth highway journeys suitable for tourists, couples, solo travelers, and family vacations. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the route. Pickup services are available across Dombivli including homes, offices, hotels, and nearby areas. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Kalyan Dombivli to Goa Outstation Cab",
    description: "Kalyan Dombivli to Goa outstation cab service provides dependable long-distance transportation for comfortable Goa road journeys. Vehicles ensure reliable highway travel suitable for tourism, sightseeing tours, and family holidays. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Kalyan Dombivli. Flexible booking options allow convenient outstation cab reservations."
  },
  {
    name: "Kalyan to Goa Innova Crysta",
    description: "Kalyan to Goa Innova Crysta service offers luxury transportation with premium seating and smooth highway performance for Goa vacations. Innova Crysta vehicles are suitable for family travel, tourism trips, corporate journeys, and VIP transportation. Professional chauffeurs ensure reliable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby areas across Kalyan. Flexible booking options allow convenient Innova Crysta reservations."
  },
  {
    name: "Dombivli to Goa Sedan Cab",
    description: "Dombivli to Goa sedan cab service offers comfortable transportation for solo travelers, couples, and business passengers visiting Goa. Sedan vehicles ensure smooth and safe highway journeys suitable for long-distance travel and tourism trips. Professional chauffeurs ensure dependable pickup and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby locations across Dombivli. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "Kalyan to Goa Luxury Taxi",
    description: "Kalyan to Goa luxury taxi service provides premium transportation with luxury vehicles for travelers planning comfortable Goa vacations. Vehicles ensure spacious seating and smooth highway journeys suitable for tourism, family holidays, and executive travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby areas across Kalyan. Flexible booking options allow convenient luxury taxi reservations."
  },
  {
    name: "Kalyan Dombivli to Goa AC Cab",
    description: "Kalyan Dombivli to Goa AC cab service offers air-conditioned transportation for comfortable and relaxing road journeys to Goa. Vehicles ensure smooth and cool highway travel suitable for tourism, family vacations, and beach holidays. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby areas across Kalyan Dombivli. Flexible booking options allow convenient AC cab reservations."
  },
  {
    name: "Bhiwandi to Goa Cabs",
    description: "Bhiwandi to Goa cabs service provides dependable transportation for travelers planning direct road trips from Bhiwandi to Goa. Comfortable vehicles ensure reliable highway journeys suitable for tourism, sightseeing tours, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby locations across Bhiwandi. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Bhiwandi to Goa Cab Service",
    description: "Bhiwandi to Goa cab service offers premium transportation for passengers seeking comfortable Goa road travel from Bhiwandi. Vehicles ensure smooth highway journeys suitable for beach holidays, tourism travel, and family outings. Professional chauffeurs ensure punctual pickup and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and nearby areas across Bhiwandi. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Bhiwandi to Goa Taxi",
    description: "Bhiwandi to Goa taxi service provides reliable transportation for travelers planning comfortable and safe Goa road journeys. Vehicles ensure smooth highway travel suitable for sightseeing tours, tourism trips, and weekend vacations. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby locations across Bhiwandi. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Bhiwandi to Goa One Way Cab",
    description: "Bhiwandi to Goa one way cab service provides affordable transportation for travelers requiring direct one-side travel to Goa. Comfortable vehicles ensure reliable highway journeys suitable for solo travelers, tourists, couples, and family vacations. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available across Bhiwandi including homes, offices, hotels, and nearby areas. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Bhiwandi to Goa Cab Booking",
    description: "Bhiwandi to Goa cab booking service provides easy transportation reservations for travelers planning Goa road trips from Bhiwandi. Comfortable vehicles ensure smooth highway travel suitable for tourism, holiday travel, and family vacations. Professional chauffeurs ensure dependable pickup and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby locations across Bhiwandi. Flexible booking options allow convenient cab booking reservations."
  },
  {
    name: "Bhiwandi to Goa Outstation Taxi",
    description: "Bhiwandi to Goa outstation taxi service provides dependable long-distance transportation for travelers planning Goa vacations from Bhiwandi. Vehicles ensure reliable highway journeys suitable for tourism, sightseeing tours, and family holidays. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby areas across Bhiwandi. Flexible booking options allow convenient outstation taxi reservations."
  },
  {
    name: "Bhiwandi to Goa Innova Cab",
    description: "Bhiwandi to Goa Innova cab service provides spacious transportation for families and groups traveling comfortably to Goa. Innova vehicles ensure smooth highway journeys with comfortable seating and luggage capacity suitable for long-distance travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, and nearby locations across Bhiwandi. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Bhiwandi to Goa Ertiga Cab",
    description: "Bhiwandi to Goa Ertiga cab service offers economical and spacious transportation for small families and groups planning Goa vacations. Ertiga vehicles ensure comfortable highway journeys suitable for tourism, beach holidays, and sightseeing travel. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby areas across Bhiwandi. Flexible booking options allow convenient Ertiga cab reservations."
  },
  {
    name: "Palghar to Goa Cab Service",
    description: "Palghar to Goa cab service provides reliable transportation for travelers planning direct road journeys from Palghar to Goa. Comfortable vehicles ensure smooth highway travel suitable for tourism, family vacations, and sightseeing tours. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby locations across Palghar. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Palghar to Goa Cabs",
    description: "Palghar to Goa cabs service offers comfortable transportation for travelers seeking smooth and reliable Goa road trips from Palghar. Vehicles ensure safe highway journeys suitable for tourism, beach holidays, and family outings. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby areas across Palghar. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Palghar to Goa Taxi Service",
    description: "Palghar to Goa taxi service provides dependable transportation with comfortable vehicles for travelers planning Goa vacations. Vehicles ensure reliable highway travel suitable for tourism travel, sightseeing tours, and weekend holidays. Professional chauffeurs ensure safe driving and smooth transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby locations across Palghar. Flexible booking options allow convenient taxi service reservations."
  },
  {
    name: "Palghar to Goa Cab Booking",
    description: "Palghar to Goa cab booking service provides quick and convenient transportation reservations for travelers planning Goa road trips. Comfortable vehicles ensure smooth highway journeys suitable for tourism, family holidays, and sightseeing travel. Professional chauffeurs ensure dependable pickup and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby areas across Palghar. Flexible booking options allow convenient cab booking reservations."
  },
  {
    name: "Palghar to Goa One Way Cab",
    description: "Palghar to Goa one way cab service provides affordable transportation for travelers requiring direct one-side travel to Goa. Vehicles ensure smooth highway journeys suitable for solo travelers, tourists, couples, and family vacations. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available across Palghar including homes, offices, hotels, and nearby locations. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Palghar to Goa Outstation Cab",
    description: "Palghar to Goa outstation cab service offers dependable long-distance transportation for travelers planning comfortable Goa road trips. Comfortable vehicles ensure reliable highway travel suitable for tourism, beach holidays, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and nearby areas across Palghar. Flexible booking options allow convenient outstation cab reservations."
  },
  {
    name: "Palghar to Goa Innova Crysta",
    description: "Palghar to Goa Innova Crysta service provides luxury transportation with premium interiors and smooth highway performance for Goa vacations. Innova Crysta vehicles are ideal for family travel, tourism trips, executive journeys, and VIP transportation. Professional chauffeurs ensure reliable pickup and premium transportation services throughout the route. Pickup services are available from homes, hotels, offices, and nearby locations across Palghar. Flexible booking options allow convenient Innova Crysta reservations."
  }
],

tableData: [
  ["Thane to Goa Cabs", "Thane to Goa Cab Service"],
  ["Thane to Goa Taxi Service", "Thane to Goa Cab Booking"],
  ["Thane to Goa One Way Cab", "Thane to Goa Outstation Cab"],
  ["Thane to Goa Innova Cab", "Thane to Goa Innova Crysta Cab"],
  ["Thane to Goa Ertiga Cab", "Thane to Goa Luxury Cab"],
  ["Thane to Goa AC Taxi Service", "Ghodbunder to Goa Cab Service"],
  ["Ghodbunder Road to Goa Cabs", "Ghodbunder to Goa Taxi"],
  ["Ghodbunder to Goa One Way Cab", "Ghodbunder to Goa Outstation Cab"],
  ["Ghodbunder to Goa Cab Booking", "Ghodbunder to Goa Innova Cab"],
  ["Ghodbunder to Goa Ertiga Cab", "Kalyan Dombivli to Goa Cabs"],
  ["Kalyan to Goa Cab Service", "Dombivli to Goa Taxi Service"],
  ["Kalyan to Goa Cab Booking", "Dombivli to Goa One Way Cab"],
  ["Kalyan Dombivli to Goa Outstation Cab", "Kalyan to Goa Innova Crysta"],
  ["Dombivli to Goa Sedan Cab", "Kalyan to Goa Luxury Taxi"],
  ["Kalyan Dombivli to Goa AC Cab", "Bhiwandi to Goa Cabs"],
  ["Bhiwandi to Goa Cab Service", "Bhiwandi to Goa Taxi"],
  ["Bhiwandi to Goa One Way Cab", "Bhiwandi to Goa Cab Booking"],
  ["Bhiwandi to Goa Outstation Taxi", "Bhiwandi to Goa Innova Cab"],
  ["Bhiwandi to Goa Ertiga Cab", "Palghar to Goa Cab Service"],
  ["Palghar to Goa Cabs", "Palghar to Goa Taxi Service"],
  ["Palghar to Goa Cab Booking", "Palghar to Goa One Way Cab"],
  ["Palghar to Goa Outstation Cab", "Palghar to Goa Innova Crysta"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Thane to Goa Cab Service",
    WhyChoosedescription: "Om Sai Cab Service provides reliable Thane to Goa cab service with professional drivers, comfortable vehicles, and smooth long-distance travel for tourists, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Affordable Thane to Goa Taxi Fare",
    WhyChoosedescription: "Our Thane to Goa taxi service offers affordable pricing with transparent fare details and no hidden charges for one-way and round-trip travel bookings."
  },
  {
    WhyChooseheading: "24/7 Goa Cab Availability from Thane",
    WhyChoosedescription: "Om Sai Cab Service operates 24 hours a day for Thane to Goa cab bookings including airport transfers, beach vacations, weekend trips, and emergency outstation travel."
  },
  {
    WhyChooseheading: "Comfortable AC Cabs for Goa Travel",
    WhyChoosedescription: "All Thane to Goa taxis are fully air-conditioned, sanitized, clean, and maintained regularly to provide smooth and comfortable highway journeys."
  },
  {
    WhyChooseheading: "One Way & Round Trip Goa Cab Booking",
    WhyChoosedescription: "Customers can choose one-way Thane to Goa cab service, round-trip taxi bookings, return journey options, and customized Goa sightseeing packages."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options Available",
    WhyChoosedescription: "Om Sai Cab Service offers sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers suitable for solo travelers, families, and group tours."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Thane City",
    WhyChoosedescription: "We provide convenient pickup service from Ghodbunder Road, Majiwada, Kasarvadavali, Kalyan, Dombivli, hotels, homes, railway stations, and all major Thane areas."
  },
  {
    WhyChooseheading: "Experienced Drivers for Goa Highway Routes",
    WhyChoosedescription: "Our experienced drivers are familiar with Thane to Goa highway routes, coastal roads, and ghat sections to ensure safe driving and timely arrival."
  }
]
};

const faqData = [
  {
    question: "What is Thane to Goa cab service?",
    answer: "Thane to Goa cab service provides comfortable taxi transportation from Thane to Goa for vacations, sightseeing tours, family travel, and outstation journeys."
  },
  {
    question: "Is Thane to Goa cab service available 24 hours?",
    answer: "Yes, Om Sai Cab Service provides 24/7 Thane to Goa taxi service."
  },
  {
    question: "Which vehicles are available for Thane to Goa travel?",
    answer: "Customers can choose sedan taxis, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers."
  },
  {
    question: "Can I book a one-way cab from Thane to Goa?",
    answer: "Yes, one-way as well as round-trip Thane to Goa cab bookings are available."
  },
  {
    question: "Do you provide pickup from all Thane locations?",
    answer: "Yes, pickup service is available from all major Thane areas including Ghodbunder Road, Majiwada, Kalyan, Dombivli, and Kasarvadavali."
  },
  {
    question: "Are all Thane to Goa taxis air-conditioned?",
    answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel."
  },
  {
    question: "Can I book Thane to Goa cab service online?",
    answer: "Yes, customers can easily book Thane to Goa cab service online or through phone booking."
  },
  {
    question: "Do you provide Goa sightseeing and travel packages?",
    answer: "Yes, customized Goa sightseeing and family holiday packages are available for beaches, temples, forts, and tourist attractions."
  },
  {
    question: "Are Thane to Goa cab fares transparent?",
    answer: "Yes, Om Sai Cab Service provides affordable and transparent taxi pricing without hidden charges."
  },
  {
    question: "Is advance booking available for Thane to Goa cabs?",
    answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak Goa travel seasons."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Patil",
    feedback: "Used Om Sai Cab Service for a Thane to Goa trip and was extremely satisfied with the service. The driver was professional, and the cab offered a comfortable ride throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Deshmukh",
    feedback: "Our travel from Thane to Goa was made easy with Om Sai Cab Service. Timely pickup, a clean vehicle, and a smooth drive made the entire experience enjoyable.",
    rating: 5
  }
];


















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai to Goa Cab", link: "Mumbai-to-Goa-Cab" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Goa Cab Booking", link: "Mumbai-to-Goa-Cab-Booking" },
        { place: "/images/keyword/3.jpg", text: "Navi Mumbai to Goa Cab Service", link: "Navi-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/4.jpg", text: "Mumbai Airport to Goa Cab", link: "Mumbai-Airport-to-Goa-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Goa Cab Service", link: "Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Best Mumbai to Goa Cab Service", link: "Best-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/7.jpg", text: "Thane to Goa Cabs", link: "Thane-to-Goa-Cabs" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Goa Innova Crysta Cab", link: "Mumbai-to-Goa-Innova-Crysta-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Goa One Way Cab", link: "Mumbai-to-Goa-One-Way-Cab" },
        { place: "/images/keyword/10.jpg", text: "Goa Cabs Service", link: "Goa-Cabs-Service" },
        { place: "/images/keyword/11.jpg", text: "Goa to Mumbai Cab", link: "Goa-to-Mumbai-Cab" },
        { place: "/images/keyword/12.jpg", text: "Goa to Navi Mumbai Cab", link: "Goa-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/13.jpg", text: "Goa to Mumbai Airport Cab", link: "Goa-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/14.jpg", text: "Goa to Mumbai One Way Cab", link: "Goa-to-Mumbai-One-Way-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/16.jpg", text: "Lonavala to Mumbai Cab", link: "Lonavala-to-Mumbai-Cab" },
        { place: "/images/keyword/17.jpg", text: "Best Lonavala to Navi Mumbai Cab", link: "Best-Lonavala-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/18.jpg", text: "Navi Mumbai Airport Cab", link: "Navi-Mumbai-Airport-Cab" },
        { place: "/images/keyword/19.jpg", text: "Navi Mumbai Cab Service", link: "Navi-Mumbai-Cab-Service" },
        { place: "/images/keyword/20.jpg", text: "Kharghar Taxi Services", link: "Kharghar-Taxi-Services" },
        { place: "/images/keyword/21.jpg", text: "Mumbai Airport Cabs", link: "Mumbai-Airport-Cabs" },
        { place: "/images/keyword/22.jpg", text: "Mumbai Cab Service", link: "Mumbai-Cab-Service" },
        { place: "/images/keyword/23.jpg", text: "Mumbai Online Cab Service", link: "Mumbai-Online-Cab-Service" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/25.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/26.jpg", text: "Innova Crysta On Rent in Mumbai", link: "Innova-Crysta-On-Rent-in-Mumbai" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Thane to Goa Cab Service",
  "image": "http://www.omsaicabservice.com/assets/images/thane-to-goa-cabs.jpg",
  "description": "Book Thane to Goa cab service with Om Sai Cab Service for one-way and round-trip travel. Affordable Sedan, SUV, Ertiga, Innova Crysta, luxury AC taxis, and outstation cabs available from Thane, Ghodbunder Road, Kalyan, and Dombivli to Goa with 24x7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Om Sai Cab Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "http://www.omsaicabservice.com/thane-to-goa-cabs"
  }
};








    return (
        <div>

<Helmet>
  <title>
    Thane to Goa Cabs | One Way & Outstation Taxi Service | +91 9594849797
  </title>

  <meta
    name="description"
    content="Book Thane to Goa cab service with affordable one-way and outstation taxi fares. Sedan, SUV, Ertiga, Innova Crysta, and luxury AC cabs available from Thane, Ghodbunder Road, Kalyan, and Dombivli to Goa."
  />

  <meta
    name="keywords"
    content="Thane to Goa Cabs, Thane to Goa Cab Service, Thane to Goa Taxi Service, Thane to Goa Cab Booking, Thane to Goa One Way Cab, Thane to Goa Outstation Cab, Thane to Goa Innova Cab, Thane to Goa Innova Crysta Cab, Thane to Goa Ertiga Cab, Thane to Goa Luxury Cab, Thane to Goa AC Taxi Service, Ghodbunder to Goa Cab Service, Ghodbunder Road to Goa Cabs, Ghodbunder to Goa Taxi, Ghodbunder to Goa One Way Cab, Ghodbunder to Goa Outstation Cab, Ghodbunder to Goa Cab Booking, Ghodbunder to Goa Innova Cab, Ghodbunder to Goa Ertiga Cab, Kalyan Dombivli to Goa Cabs, Kalyan to Goa Cab Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row align-items-center text-center">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/7.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FFCC00', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Om Sai Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Om Sai Cab</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Om Sai Cab </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                             <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919594849797" className="pc-call">+91 9594849797</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919594849797"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919594849797" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@omsaicabservice.com" className="pc-email">
                                            booking@omsaicabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Om Sai Cab Service</strong><br />
                                            Shree Vishal CHS Ltd., Plot No.17,
                                            Sector 18, Kopar Khairane, Navi Mumbai,
                                            Maharashtra- India - 400709
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Thanetogoacabs;